import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'discount',
    standalone: false
})
export class DiscountPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const price = args.discount ? args.SellRate - (args.SellRate * args.discount / 100) : args.SellRate;
    return price
  }

}
